import { Mapper } from "../../../../base/utils/mapper";
import { SubjetiveResponseModel } from "../../../../domain/models/consult/subjetive-response.model";
import { SubjetiveResponseEntity } from "../entities/subjetive-response.entity";


export class SubjetiveImplementationRepositoryMapper extends Mapper<SubjetiveResponseEntity, SubjetiveResponseModel> {
    mapFrom(param: SubjetiveResponseEntity): SubjetiveResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: SubjetiveResponseModel): SubjetiveResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}